import * as actionTypes from '../actions/sessionActions';

const initialState = {
  loggedIn: false,
  user: {},
  loginLoading: false,
  nested_menus: [],
  user_Permissions: [],
  user_permissions_raw: [],
  current_page_permissions: [],
  error: "",
  error_type: "",
  redirect_to_login: false,
};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOGIN_REQUEST:
      return {
        ...state,
        loginLoading: true,
        error: "",
        error_type: '',
        user: [],
        redirect_to_login: false,
      };
      
    case actionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        loginLoading: false,
        user: action.payload,
        error: "",
        loggedIn: true,
        user_Permissions: action.user_Permissions,
        user_permissions_raw: action.user_permissions_raw,
        nested_menus: action.nested_menus,
        error_type: '',
        redirect_to_login: false,
      };
      
      case actionTypes.CURRENT_PAGE_PERMISSIONS:
        return {
          ...state,
          current_page_permissions: action.current_page,
        }
        
    case actionTypes.LOGIN_FAILURE:
      return {
        ...state,
        loggedIn: false,
        loginLoading: false,
        user: [],
        error: action.payload,
        error_type: action.error_type,
        redirect_to_login: true, 
      };
      
      case actionTypes.RESET_SESSION:
        return {
          ...state,
          loggedIn: false,
          user: {},
          verify_user: {},
          loginLoading: false,
          is_disclaimer_shown: false,
          show_email_varification: false,
          error: "",
          error_type: "",
          nested_menus: [],
          user_Permissions: [],
          user_permissions_raw: [],
          current_page_permissions: []
        }
      
    case actionTypes.SESSION_LOGOUT:
      return {
        ...state,
        loggedIn: false,
        user: {},
        loginLoading: false,
        current_page_permissions: [],
        error: "",
        error_type: '',
        redirect_to_login: false,
      };
      
    case actionTypes.TOKEN_EXPIRE:
      return {
        ...state,
        loggedIn: false,
        user: {},
        user_Permissions: [],
        user_permissions_raw: [],
        nested_menus: [],
      };

    case actionTypes.REDIRECT_TO_LOGIN:
      return {
        ...state,
        loginLoading: false,
        redirect_to_login: true,
      };

    default:
      return state;
  }
};

export default sessionReducer;
